import { queryOptions, useQuery } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

function getConfigQuery(opts: RequestOpts = {}) {
  const queryKey = ['getConfig'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return api.getConfig({
        ...opts,
        signal,
      });
    },
    staleTime: ms('5m'),
    gcTime: ms('10m'),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchConfigQuery(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getConfigQuery(opts));
}

export function useConfig() {
  return useQuery(getConfigQuery());
}
